import { t } from '@lingui/macro';

import Image from '../../generic/Image';

const CartProductImage = ({ productImage }) => {
  return <Image imageUrl={productImage} alt={t`Product image`} maxW={{ base: '100%', md: '130px' }} mt={{ base: '.5rem', md: '0' }} />;
};

export default CartProductImage;
